import { useCallback } from 'react'
import { useTheme } from 'styled-components'

export const useProgressColor = () => {
  const theme = useTheme()
  const progressColor = useCallback(
    (progress) => {
      if (progress >= 100) {
        return theme.colorPrimary
      }
      if (progress >= 75) {
        return theme.colorBrightGreen500 ?? '#7CC334'
      }
      if (progress >= 50) {
        return theme.colorBrightYellow500 ?? '#FACC00'
      }
      if (progress >= 25) {
        return '#E47C00'
      }
      return theme.colorBrightRed500 ?? '#FF4A4A'
    },
    [theme],
  )
  return { progressColor }
}
